import React from 'react';

const viSend = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="currentColor" d="M1.5 21l21-9-21-9v7l15 2-15 2z" />
    </g>
  </svg>
);

export default viSend;
